<template>
  <panel-noticias caritas />
</template>

<script>
import panelNoticias from "@/components/dashboard/PanelNoticias.vue";

export default {
  name: "VistaEditorNoticiasCaritas",
  components: {
    panelNoticias,
  },
};
</script>
